// Auto-import handoff: a future opportunities tool (or any other
// producer) writes the AutoImportPayload JSON to sessionStorage
// under this key, then navigates to
// /tools/production-schedule?import=1.
//
// On consume, the key is deleted whether or not parsing succeeded
// — a corrupt payload should not stay around through reloads.
import {
  AutoImportPayload,
  type AutoImportPayloadT,
} from "../../../../../../shared/types/production-schedule";
import type { JobFormState } from "../modals/JobFormFields";
import { emptyForm } from "../modals/jobFormState";
import { addDays, isoToday } from "./dates";

export const AUTO_IMPORT_KEY = "bsp:prod-schedule:auto-import";

export function consumeAutoImport(): AutoImportPayloadT | null {
  if (typeof window === "undefined") return null;
  const raw = sessionStorage.getItem(AUTO_IMPORT_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(AUTO_IMPORT_KEY);
  try {
    const parsed = AutoImportPayload.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

export function autoImportToFormState(p: AutoImportPayloadT): JobFormState {
  const base = emptyForm();
  return {
    ...base,
    name: p.name,
    customer: p.customer ?? "",
    notes: p.notes ?? "",
    solutionTypeId: p.solutionTypeId ?? null,
    priority: p.priority ?? "Normal",
    dueDate: p.dueDate ?? addDays(isoToday(), 14),
  };
}
